import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea91su3v1n6nioxn as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_isFailure__impl__jpiriv131ia60azkd5j as _Result___get_isFailure__impl__jpiriv,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { pipelineStartCoroutineUninterceptedOrReturn3fvxhza76tp2 as pipelineStartCoroutineUninterceptedOrReturn } from './PipelineJs.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { recoverStackTraceBridge1qu82j8ymuquf as recoverStackTraceBridge } from './StackTraceRecover.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function loop($this, direct) {
  do {
    var currentIndex = $this.p4r_1;
    if (currentIndex === $this.k4r_1.v2()) {
      if (!direct) {
        // Inline function 'kotlin.Companion.success' call
        var value = $this.m4r_1;
        var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
        resumeRootWith($this, tmp$ret$0);
        return false;
      }
      return true;
    }
    $this.p4r_1 = currentIndex + 1 | 0;
    var next = $this.k4r_1.w2(currentIndex);
    try {
      var result = pipelineStartCoroutineUninterceptedOrReturn(next, $this, $this.m4r_1, $this.l4r_1);
      if (result === get_COROUTINE_SUSPENDED())
        return false;
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
        resumeRootWith($this, tmp$ret$1);
        return false;
      } else {
        throw $p;
      }
    }
  }
   while (true);
}
function resumeRootWith($this, result) {
  if ($this.o4r_1 < 0) {
    // Inline function 'kotlin.error' call
    var message = 'No more continuations to resume';
    throw IllegalStateException().o(toString(message));
  }
  var next = ensureNotNull($this.n4r_1[$this.o4r_1]);
  var _unary__edvuaz = $this.o4r_1;
  $this.o4r_1 = _unary__edvuaz - 1 | 0;
  $this.n4r_1[_unary__edvuaz] = null;
  if (!_Result___get_isFailure__impl__jpiriv(result)) {
    next.tc(result);
  } else {
    var exception = recoverStackTraceBridge(ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result)), next);
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    next.tc(tmp$ret$0);
  }
}
function discardLastRootContinuation($this) {
  if ($this.o4r_1 < 0)
    throw IllegalStateException().o('No more continuations to resume');
  var _unary__edvuaz = $this.o4r_1;
  $this.o4r_1 = _unary__edvuaz - 1 | 0;
  $this.n4r_1[_unary__edvuaz] = null;
}
var SuspendFunctionGun$continuation$1Class;
function SuspendFunctionGun$continuation$1() {
  if (SuspendFunctionGun$continuation$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.r4r_1 = this$0;
        this.q4r_1 = -2147483648;
      }
      rc() {
        var continuation = this.r4r_1.n4r_1[this.r4r_1.o4r_1];
        if (!(continuation === this) && !(continuation == null))
          return continuation.rc();
        var index = this.r4r_1.o4r_1 - 1 | 0;
        while (index >= 0) {
          var _unary__edvuaz = index;
          index = _unary__edvuaz - 1 | 0;
          var cont = this.r4r_1.n4r_1[_unary__edvuaz];
          if (!(cont === this) && !(cont == null))
            return cont.rc();
        }
        // Inline function 'kotlin.error' call
        var message = 'Not started';
        throw IllegalStateException().o(toString(message));
      }
      al(result) {
        if (_Result___get_isFailure__impl__jpiriv(result)) {
          // Inline function 'kotlin.Companion.failure' call
          var exception = ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result));
          var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
          resumeRootWith(this.r4r_1, tmp$ret$0);
          return Unit_instance;
        }
        loop(this.r4r_1, false);
      }
      tc(result) {
        return this.al(result);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Continuation()]);
    SuspendFunctionGun$continuation$1Class = $;
  }
  return SuspendFunctionGun$continuation$1Class;
}
var SuspendFunctionGunClass;
function SuspendFunctionGun() {
  if (SuspendFunctionGunClass === VOID) {
    class $ extends PipelineContext() {
      constructor(initial, context, blocks) {
        super(context);
        this.k4r_1 = blocks;
        var tmp = this;
        tmp.l4r_1 = new (SuspendFunctionGun$continuation$1())(this);
        this.m4r_1 = initial;
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.k4r_1.v2();
        tmp_0.n4r_1 = Array(size);
        this.o4r_1 = -1;
        this.p4r_1 = 0;
      }
      ew() {
        return this.l4r_1.rc();
      }
      c4q() {
        return this.m4r_1;
      }
      e4q($completion) {
        var tmp$ret$0;
        $l$block_0: {
          if (this.p4r_1 === this.k4r_1.v2()) {
            tmp$ret$0 = this.m4r_1;
            break $l$block_0;
          }
          this.s4r(intercepted($completion));
          if (loop(this, true)) {
            discardLastRootContinuation(this);
            tmp$ret$0 = this.m4r_1;
            break $l$block_0;
          }
          tmp$ret$0 = get_COROUTINE_SUSPENDED();
        }
        return tmp$ret$0;
      }
      d4q(subject, $completion) {
        this.m4r_1 = subject;
        return this.e4q($completion);
      }
      f4q(initial, $completion) {
        this.p4r_1 = 0;
        if (this.p4r_1 === this.k4r_1.v2())
          return initial;
        this.m4r_1 = initial;
        if (this.o4r_1 >= 0)
          throw IllegalStateException().o('Already started');
        return this.e4q($completion);
      }
      s4r(continuation) {
        this.o4r_1 = this.o4r_1 + 1 | 0;
        this.n4r_1[this.o4r_1] = continuation;
      }
    }
    initMetadataForClass($, 'SuspendFunctionGun', VOID, VOID, VOID, [0, 1]);
    SuspendFunctionGunClass = $;
  }
  return SuspendFunctionGunClass;
}
//region block: exports
export {
  SuspendFunctionGun as SuspendFunctionGun278ui80hj12zj,
};
//endregion

//# sourceMappingURL=SuspendFunctionGun.mjs.map
